import React from 'react';
import {ISearchContext, ISearchQueue} from '../Types/ISearchContext';

const searchContext: React.Context<ISearchContext> = React.createContext({
        setQueue: (newQueue: ISearchQueue) => newQueue,
        setFinishedQueue: (finishedQueue: ISearchQueue) => finishedQueue,
        queue: []
} as ISearchContext);

export default searchContext;
